const inputModel = {
    title: {
      label: 'general.tags.title',
      translate: true,
      name: 'title',
      value: null,
      rest: {
        type: 'alphaNumeric',
      },
    },
    description: {
      label: 'general.tags.description',
      translate: true,
      name: 'description',
      value: null,
      rest: {
        multiline: true,
        rows: 3,
      },
    },
  }

  export { inputModel }